export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/google_data_studio.c239d30.svg";